import React, { useEffect, useRef, useState } from 'react';
import CheckBox from '../CheckBox'
import { useParams } from 'react-router-dom';
import axios from "axios";
import API_URL from "../../constant/api.config";
import Choosefile from '../../components/Choosefile';
import inputicon from "../../images/Image _placeholder.svg"
import pdf from "../../images/sidebarImages/pdf_icon.svg"
import errorMessages from '../../constant/errorMessages';
import { connect } from 'react-redux';
import { addCertificateAction, getMemberCertificateAction, deleteCertificate, getOptionListAdmin, getCertificateSearchList, getSelectedCertificateListByIdList } from "../../actions/certificateAction";
import { filter, find, includes, map, size } from 'lodash';
import defaultValues from '../../constant/defaultValues';
import SmallPopup from "../../components/SmallPopup";
import MediumPopup from "../../components/MediumPopup";
import { showSuccessMessage, showErrorMessage } from '../../utils/common';
import InputField from '../InputField'
import { isEmpty, replace } from "lodash";
import { default as ReactSelect } from "react-select";
import { useAuth } from "../../AuthProvider";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import regExp from "../../constant/regExpressions";
import { getMemberTradeMode } from "../../actions/updateProfileAction";
import ButtonAdminpanel from '../ButtonAdminpanel';

function LogisticPartnerCertificate({ addCertificates, name, ...props }) {
  const { isSuperAdmin, isEndUser, isPreKYCUser, trade_mode_type, isViewer, isOpUser, isInqUser } = useAuth();
  const { IMAGE_PATH } = defaultValues;
  const PATH = IMAGE_PATH.BASE_URL;
  const { id } = useParams();
  const [certificateLists, setCertificateList] = useState([]); // Business + AEO certificates from dictionary 
  const [selectedCertificates, setSelectedCertificates] = useState({});
  const [formdata, setFormData] = useState({});
  const [formdata2, setFormData2] = useState({});
  const [verrors, setVErrors] = useState({});
  const [verrors2, setVErrors2] = useState({});
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
  const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);

  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [deletecertificateId, setDeleteCertiId] = useState();
  const [docImagePath, setDocImagePath] = useState();
  const [docPdfPath, setDocPdfPath] = useState();
  const [mediummodalShow2, setMediumModalShow2] = useState(false);

  const [selectedAdditionalCertificates, setselectedAdditionalCertificates] = useState([]);


  var [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [otherCheck, setOtherCheck] = useState(false);

  const [otherCerti, setOtherCerti] = useState("");
  const [errors, setErrors] = useState({});

  const [filenamepdf, setFilenamepdf] = useState('');
  const [existingFiles, setExistingFiles] = useState({});


  const [file1, setFile] = useState({});

  const [pdfIcon, setselectFilePDF] = useState(pdf);

  const [additionalCerti, setAdditionalCerti] = useState([]);
  const [existingAdditionalCertificates, setExistingAdditionalCertificates] = useState([]);

  const [existingOtherCertificate, setExistingOtherCertificates] = useState("");
  const [existingCertificateName, setExistingOthercertificateName] = useState("");

  const style2 = {
    height: '50px',
    width: '50px',
  };
  const style3 = {
    height: '100%',
    width: '100%',
  };

  const styleError = {
    display: 'block',
  };

  const handleOtherOptionCheckbox = ((val) => {
    setErrors({});
    if (val === false) {
      setOtherCerti("");
    } else {
      if (existingCertificateName) {
        setOtherCerti(existingCertificateName);
      }
    }

    setOtherCheck(val);
    if (val === false) {
      setisButtonDisabled(false);
    }

  });

  const handleAdditionalCheckboxChange = (id, slug, name) => {
    setselectedAdditionalCertificates((prev) => {
      let found = find(prev, (item) => (item.certificate_id === id));
      if (found) {
        return prev.filter((item) => {
          return item.certificate_id != id;
        });
      } else {
        return [...prev, {
          id: null,
          certificate_id: id,
          slug: slug,
          certi_name: name,
          certi_file: null
        }]
      }
    });
  };

  const handleBusinessTaxCertiChange = (e) => {
    const { name, files } = e.target;
    const [type, slug] = name.split("#@");

    let error = '';
    if (files.length > 0) {
      const file = files[0];

      if (!ALLOWED_TYPES.includes(file.type)) {
        // error = "Invalid file type. Only PDF, JPEG, and PNG are allowed."; // The file must be a file of type
        error = "The file must be a file of type jpg, png, jpeg or pdf";
      }
      else if (file.size > MAX_FILE_SIZE) {
        // error = "File size exceeds 2MB limit.";
        // console.log("File Size =============", file.size);
        error = "The file must be less than or equal to 2 MB";
      }


      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (error == "") {
        setFile(prevFile => ({
          ...prevFile,
          [`certificate#@${slug}`]: {
            path: URL.createObjectURL(file),
            fileType: fileExtension,
          },
        }));
      }

      if (error) {
        setVErrors((prev) => ({
          ...prev,
          [name]: error,
        }));
        setFormData((prev) => ({ ...prev, [name]: null }));
      } else {
        setVErrors((prev) => ({
          ...prev,
          [name]: undefined,
        }));
        setFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
        setExistingFiles((prevFile) => {
          const file = files[0];
          const isPDF = file.type === 'application/pdf';

          return {
            ...prevFile,
            [`certificate#@${slug}`]: {
              path: isPDF ? pdfIcon : URL.createObjectURL(file),
              file: file,
            },
          };
        });

      }
    } else {

      let tmpSlug = `certificate#@${slug}`;

      if (existingFiles[tmpSlug] === undefined || existingFiles[tmpSlug] === "" || existingFiles[tmpSlug] == null) {
        setFile(prevFile => ({
          ...prevFile,
          [`certificate#@${slug}`]: null,
        }));
        setFormData((prev) => ({
          ...prev,
          [name]: null,
        }));
      } else if (existingFiles[tmpSlug] !== undefined || existingFiles[tmpSlug] !== "" || existingFiles[tmpSlug] !== null) {

        let tmpPath = existingFiles[tmpSlug].path;
        let tmpArr = tmpPath.split("/");
        let fname = tmpArr[size(tmpArr) - 1];
        let fNameExt = fname.split(".")[1];
        setFile(prevFile => ({
          ...prevFile,
          [`certificate#@${slug}`]: {
            path: fname,
            fileType: fNameExt,
          },
        }));
        setFormData((prev) => ({
          ...prev,
          [name]: fname,
        }));
      }

      // setExistingFiles((prevFile) => ({
      //     ...prevFile,
      //     [`certificate#@${slug}`]: {
      //         path: URL.createObjectURL(files[0]),
      //         file: files[0],
      //     },

      // }));

    }

    const hasErrors = Object.values({ ...verrors, [name]: error }).some(err => err);
    setSubmitDisabled(hasErrors);
  };

  const handleAdditionalCertificateChange = (e, certi_slug, certi_file) => {
    const { name, files } = e.target;
    const [type, slug] = name.split("#@");
    let error = "";
    if (files.length > 0) {
      const file = files[0];

      if (!ALLOWED_TYPES.includes(file.type)) {
        // error = "Invalid file type. Only PDF, JPEG, and PNG are allowed."; // The file must be a file of type
        error = "The file must be a file of type jpg, png, jpeg or pdf";
      }
      else if (file.size > MAX_FILE_SIZE) {
        // error = "File size exceeds 2MB limit.";
        // console.log("File Size =============", file.size);
        error = "The file must be less than or equal to 2 MB";
      }

      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (error == "") {
        setAdditionalCerti(prevFile => ({
          ...prevFile,
          [`LOG_PTR#@${slug}`]: {
            path: URL.createObjectURL(file),
            fileType: fileExtension,
            file: file
          },
        }));
      }

      if (error) {

        setVErrors((prev) => ({
          ...prev,
          [name]: error,
        }));

      } else {

        setVErrors((prev) => ({
          ...prev,
          [name]: undefined,
        }));

        // Preview of current file
        setAdditionalCerti(prevFile => ({
          ...prevFile,
          [`LOG_PTR#@${slug}`]: {
            path: URL.createObjectURL(file),
            fileType: fileExtension,
            file: file
          },
        }));

        if (slug == "other_certi") {
          const isPDF = file.type === 'application/pdf'
          setExistingOtherCertificates(prevFile => ({
            ...prevFile,
            [`LOG_PTR#@other_certi`]: {
              path: isPDF ? pdfIcon : URL.createObjectURL(file),
              file: file
            },
          }));


        } else {
          //Preview of current file in replacement of exisiting uploaded file
          const isPDF = file.type === 'application/pdf';
          setExistingAdditionalCertificates(prevFile => ({
            ...prevFile,
            [`LOG_PTR#@${slug}`]: {
              path: isPDF ? pdfIcon : URL.createObjectURL(file),
              file: file
            },
          }));
        }
      }
    } else {
      console.log("File is empty");
    }
  }

  const handleFocusOut = async (e) => {
    let flag = 0;
    let er = { ...errors };
    if (e.target.name === 'other_certi') {
      if (e.target.value === '') {
        flag = 1;
        er.other_certi = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 40) {
        flag = 1;
        er.other_certi = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const certifivateregExp = regExp.otherCertificate;
        const check = certifivateregExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.other_certi = errorMessages.IN_VALID_FIELD_FORMAT;
        }
        else {
          flag = 0;
          er.other_certi = '';
        }
      }
    }
    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      setisButtonDisabled(true);
      return true;
    }

  }

  const validateBusinessTaxCertificate = async () => {
    const errors = { ...verrors };

    const selectedIds = Object.keys(selectedCertificates).filter(id => selectedCertificates[id]);

    if (selectedIds.length === 0) {
      errors.certificateOption = errorMessages.FIELD_REQUIRED;
    }
    else {
      selectedIds.forEach(id => {
        const certificate = certificateLists.find(c => c.id === parseInt(id));
        const isAadhaarCard = certificate.slug === 'AADHAAR_CARD';
        if (isAadhaarCard) {
          if (!formdata?.[`certificate_front#@${certificate.slug}`]) {
            errors[`certificate_front#@${certificate.slug}`] = errorMessages.FIELD_REQUIRED;
          }
        } else {
          if (certificate && !formdata[`certificate#@${certificate.slug}`]) {
            errors[`certificate#@${certificate.slug}`] = errorMessages.FIELD_REQUIRED;
          }
        }
      });
    }


    if (size(selectedAdditionalCertificates) > 0) {
      selectedAdditionalCertificates.forEach((cert) => {
        const certificate = certificateLists.find(c => c.id === parseInt(cert.certificate_id));
        if (certificate && !additionalCerti[`LOG_PTR#@${cert.slug}`]) {
          errors[`LOG_PTR#@${certificate.slug}`] = errorMessages.FIELD_REQUIRED;
        }
      })
    }


    let errObj = {};
    // Other Certificate validation
    if (otherCheck) {

      if (isEmpty(otherCerti)) {
        errObj.other_certi = errorMessages.FIELD_REQUIRED;
      } else if (otherCerti.length > 40) {
        errObj.other_certi = errorMessages.MAX_LENGTH_EXCEEDED;
      }

      if (!additionalCerti[`LOG_PTR#@other_certi`] && !existingOtherCertificate[`LOG_PTR#@other_certi`]) {
        errors[`LOG_PTR#@other_certi`] = errorMessages.FIELD_REQUIRED;
      }
      setErrors(errObj);
    }

    let er = {};
    map(errors, (val, key) => {
      if (val !== undefined && val !== null && val !== "") {
        er[key] = val;
      }
    });

    setVErrors(er);
    return Object.keys(er).length > 0 || Object.keys(errObj).length > 0;
  };

  const validateAdditionalCertificates = () => {
    const errors = { ...verrors };
    if (size(selectedAdditionalCertificates) > 0) {
      selectedAdditionalCertificates.forEach((cert) => {
        const certificate = certificateLists.find(c => c.id === parseInt(cert.certificate_id));
        if (certificate && !additionalCerti[`LOG_PTR#@${cert.slug}`]) {
          errors[`LOG_PTR#@${certificate.slug}`] = errorMessages.FIELD_REQUIRED;
        }
      })
    }

    // Other Certificate validation
    if (otherCheck) {
      let errObj = {};
      if (isEmpty(otherCerti)) {
        errObj.other_certi = errorMessages.FIELD_REQUIRED;
      } else if (otherCerti.length > 40) {
        errObj.other_certi = errorMessages.MAX_LENGTH_EXCEEDED;
      }

      if (!additionalCerti[`LOG_PTR#@other_certi`] && !existingOtherCertificate[`LOG_PTR#@other_certi`]) {
        errors[`LOG_PTR#@other_certi`] = errorMessages.FIELD_REQUIRED;
      }
      setErrors(errObj);
    }

    setVErrors(errors);
    return Object.keys(errors).length > 0;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    let logData = selectedAdditionalCertificates ?? [];
    let validateResult = await validateBusinessTaxCertificate();
    //let validate2Result = await validateAdditionalCertificates();
    // console.log("validateResult ============= ", validateResult);
    let validate2Result = false;
    // console.log("validate2Result >>>>>>>>>>> ", validate2Result);

    if (!validateResult && !validate2Result) {
      props.showLoading();
      setErrors({});
      let tradeMode = props.shipmentMode;
      await addCertificates(id, formdata, additionalCerti, tradeMode, logData, otherCheck, otherCerti).then((response) => {
        if (response.status === true) {
          showSuccessMessage('Data Saved successfully...');
          setTimeout(async () => {
            for (var ckey in formdata) {
              document.getElementById(ckey).value = null;
            }
            await fetchCertificateList();
            setFormData({});
            if (isSuperAdmin || isOpUser) {
              for (var ckey2 in formdata2) {
                if (document.getElementById(ckey2)) {
                  document.getElementById(ckey2).value = null;
                }

              }

            }
            props.hideLoading();
          }, 2000);
        } else if (response.status === false) {
          if (response.message === "Error") {
            const er = {};
            props.hideLoading();
            const result0 = Object.values(response.newOther.otherCerti);
            er.other_certi = result0[0];
            setErrors(er);
          }

          if (response.message === "Validation Errors") {
            props.hideLoading();

            const result0 = Object.entries(response.error.requiredCertificates);
            let newErrors = {};
            result0.forEach(([key, value]) => {
              key = replace(key, '.', '');
              newErrors[key] = value[0];
            });
            setVErrors(newErrors);

            const result1 = Object.entries(response.error.otherCertificates);
            let newErrors2 = {};
            result1.forEach(([key, value]) => {
              key = replace(key, '.', '');
              newErrors2[key] = value[0];
            });
            setVErrors2(newErrors2);
          }
        } else {
          showErrorMessage("Something went wrong");
          props.hideLoading();
        }
      }).catch((error) => {
        console.log(error);
        showErrorMessage("Something went wrong");
        props.hideLoading();
      });

    } else {
      console.log("Validation errors:", verrors);

    }
  };

  // API to get AEO - IATA Certificates
  const fetchCertificateList = async () => {
    try {
      const response = await axios.get(API_URL + "/certificates");
      if (response.status === 200 && response.data.status === true) {
        const options = response.data.data;
        setCertificateList(options);
      }
    } catch (error) {
      console.error("Error fetching certificates:", error);
      showErrorMessage("Something went wrong");
    }
  };

  // get certicateData added by Member itself
  const fetchMemberCertificate = async () => {
    try {
      const response = await props.getMemberCertificate(id);
      const existingBusinessTaxFilesMap = {};
      const businessTaxFormData = {};
      const existingAdditionalFilesMap = {};
      const existingOtherFilesMap = {};

      let member_certificates = response.data;

      /** Set Business & Tax Certificate Data - Start */
      let default_certificates = map(member_certificates, (c) => {
        if (includes(["TAX_CERTI", "BUSINESS_CERTI"], c.certificate_type)) {
          return c;
        }
      });

      default_certificates = filter(default_certificates);

      map(default_certificates, (cert) => {
        return existingBusinessTaxFilesMap[`certificate#@${cert.certificates.slug}`] = {
          path: PATH + '/member_certificates/' + cert.certificate_detail,
          mcId: cert.id
        };
      });
      setExistingFiles(existingBusinessTaxFilesMap);

      // used in validation and API calling
      map(default_certificates, (cert) => {
        return businessTaxFormData[`certificate#@${cert.certificates.slug}`] = cert.certificate_detail
      });
      setFormData(businessTaxFormData);

      /** Set Business & Tax Certificate Data - End */

      /** Set AEO - IATA Certificates */
      let additional_certificates = map(member_certificates, (c) => {
        if (!includes(["TAX_CERTI", "BUSINESS_CERTI", "Other"], c.certificate_type)) {
          return c;
        }
      });

      additional_certificates = filter(additional_certificates);

      map(additional_certificates, (cert) => {
        return existingAdditionalFilesMap[`LOG_PTR#@${cert.certificates.slug}`] = {
          path: PATH + '/member_certificates/' + cert.certificate_detail,
          mcId: cert.id
        };
      });

      let s_addiotnal_certis = map(additional_certificates, (val) => {
        return {
          id: val.id,
          certificate_id: val.certificate_id,
          slug: val.certificates.slug,
          certi_name: val.certificates.name,
          certi_file: val.certificate_detail
        }
      });

      let otherCertificate = map(member_certificates, (c) => {
        if (includes(["Other"], c.certificate_type)) {
          return c;
        }
      });

      otherCertificate = filter(otherCertificate);

      if (size(otherCertificate) > 0) {
        setOtherCheck(true);
        setOtherCerti(otherCertificate[0].certificates.name);
        setExistingOthercertificateName(otherCertificate[0].certificates.name);
      }

      map(otherCertificate, (cert) => {
        return existingOtherFilesMap[`LOG_PTR#@other_certi`] = {
          path: PATH + '/member_certificates/' + cert.certificate_detail,
          mcId: cert.id
        };
      });

      setselectedAdditionalCertificates(s_addiotnal_certis);
      setExistingAdditionalCertificates(existingAdditionalFilesMap);
      setAdditionalCerti(existingAdditionalFilesMap);

      setExistingOtherCertificates(existingOtherFilesMap);

    } catch (error) {
      console.error("Error fetching member certificates:", error);
      showErrorMessage("Something went wrong");
    }
  };

  const handleRemove = (id) => {
    setSmallModalShow(true);
    setDeleteCertiId(id);
  }

  const handleConfirmDeleteClick = async () => {
    //props.showLoading();
    await props
      .deleteCertificate(deletecertificateId)
      .then((response) => {
        setSmallModalShow(false);
        if (response.status === true) {
          setVErrors2({});
          //  props.hideLoading();
          showSuccessMessage("Deleted successfully...");
          setTimeout(async () => {

            setFormData({});
            await fetchMemberCertificate();
            setFile({});

          }, 0);
        }

      })
      .catch((err) => {
        console.log("Error == ", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleImageShow = (path) => {
    setDocImagePath(path);
    setMediumModalShow(true);
  }

  const handlePdfShow = (path) => {
    setDocPdfPath(path);
    setMediumModalShow2(true);
  }

  /** Error Handling button disable code */
  useEffect(() => {

    if (isEndUser || isPreKYCUser) {
      const anyError = Object.values({ ...verrors }).some(err => err);
      setisButtonDisabled(anyError);
    } else {
      const hasErrors1 = Object.values({ ...verrors }).some(err => err);
      const hasErrors2 = Object.values({ ...verrors2 }).some(err => err);
      const disable = hasErrors1 || hasErrors2;
      setisButtonDisabled(disable);
    }

  }, [verrors, verrors2]);

  useEffect(() => {
    if (size(certificateLists) > 0) {
      fetchMemberCertificate();

      const defaultCertificates = certificateLists.reduce((acc, certificate) => {
        if (['BUSINESS_CERTI', 'TAX_CERTI'].includes(certificate.slug)) {
          acc[certificate.id] = true;
        }
        return acc;
      }, {});

      // Set Business and Tax Certificates 
      setSelectedCertificates((prevState) => {
        const hasChanged = Object.keys(defaultCertificates).some(
          (key) => defaultCertificates[key] !== prevState[key]
        );
        return hasChanged ? defaultCertificates : prevState;
      });
    }
  }, [certificateLists]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchCertificateList(); // Function call to get certificate list

      } catch (error) {
        console.error('Error fetching data:', error);
        showErrorMessage("Something went wrong");
      }
    };
    setTimeout(async () => { fetchData(); }, 2000);
  }, []);

  return (
    <div>
      <h4 className='company-info-text'>Certificate</h4>

      <form id="account-detail" className=' p-4 pb-4 card-shadow bg-white rounded' onSubmit={handleSubmit}>
        <h4 className='head-office-text border-bottom upload-doc'>Upload Company Document</h4>

        {/** Seeting Up Tax and Business Certificate - START */}
        {certificateLists.map((certificate) => (
          <div key={certificate.id} >
            {/* {JSON.stringify(certificate)} */}
            {selectedCertificates[certificate.id] && (
              <>
                <div>
                  <div className='upload-main border-top'>

                    <div className='upload-content '>

                      <div className='upload-input'>

                        <h4 className='upload-text'>Upload {certificate.name} <span className='text-danger'>*</span></h4>

                        <Choosefile
                          className={`form-control choose-pdf ${verrors[`certificate#@${certificate.slug}`] ? 'choose-pdf-error' : ''}`}
                          type="file"
                          accept="image/jpeg, image/png, image/jpg"
                          onChange={handleBusinessTaxCertiChange}
                          name={"certificate#@" + certificate.slug}
                          disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer)}
                          id={"certificate#@" + certificate.slug}
                        />

                        {verrors[`certificate#@${certificate.slug}`] && (
                          <p className="upload-faild-text my-1">
                            <span className="certificate-required">{verrors[`certificate#@${certificate.slug}`]}</span>
                          </p>
                        )}
                        <p className='upload-info'>Allowed PDF, JPEG, JPG or PNG. Max size of 2 MB</p>
                      </div>

                      <div className={`upload-img ${verrors[`certificate#@${certificate.slug}`] ? 'upload-img-error' : ''} `}>

                        <div className={`position-relative ${props.isDisable || props.disableProfile || isViewer ? ` ` : `certificate-img-hover`} `}>

                          {existingFiles[`certificate#@${certificate.slug}`] ? (
                            existingFiles[`certificate#@${certificate.slug}`].path.endsWith('.pdf') ? (
                              <img src={pdf} alt="PDF Icon" style={style2} id="pdf-img" onClick={() => handlePdfShow(existingFiles[`certificate#@${certificate.slug}`]?.path)} className='line-964' />
                            ) : (
                              <img src={existingFiles[`certificate#@${certificate.slug}`].path} alt="" style={style2} id="pdf-img" onClick={() => handleImageShow(existingFiles[`certificate#@${certificate.slug}`]?.path)} className='line-966' />
                            )
                          ) : file1[`certificate#@${certificate.slug}`] ? (
                            file1[`certificate#@${certificate.slug}`].fileType === 'pdf' ? (
                              <img
                                src={pdf}
                                alt='PDF'
                                style={style2}
                                id="pdf-img"
                              />
                            ) : (
                              <img
                                src={file1[`certificate#@${certificate.slug}`].path}
                                alt={file1[`certificate#@${certificate.slug}`].path}
                                style={style2}
                                id="pdf-img"
                                className='line-982'
                              />
                            )
                          ) : (
                            <></>
                          )}

                          <p className='upload-info'>{filenamepdf}</p>

                          {!isViewer && !isInqUser && !props.disableProfile && existingFiles[`certificate#@${certificate.slug}`]?.mcId && (
                            <button className='pdf-close' type='button' onClick={() => handleRemove(existingFiles[`certificate#@${certificate.slug}`]?.mcId)} disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer)}>
                              <i className="fa-regular fa-trash-can text-danger"></i>
                            </button>
                          )}

                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </>
            )}

          </div>

        )

        )}

        {/** Seeting Up Tax and Business Certificate - END */}

        {/** Setting Up AEO - IATA Certificate - START */}
        {
          <div className='border-top other-certificate-main'>
            <h4 className='upload-text'>Other Certificates</h4>
            <div className='certificate-main'>
              {certificateLists.map((certificate) => (
                <>
                  {certificate.trade_mode === 'Logistic Partner' && certificate.slug !== 'BUSINESS_CERTI' && certificate.slug !== 'TAX_CERTI' && (
                    <div key={certificate.id} className='certificate-child-first log-certificate'>
                      <div className="certificate-child-secound">
                        <CheckBox
                          //checked={selectedCertificates3.includes(certificate.id)}
                          checked={find(selectedAdditionalCertificates, (item) => (item.certificate_id === certificate.id))}
                          onChange={() => handleAdditionalCheckboxChange(certificate.id, certificate.slug, certificate.name)}
                          disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer)}

                        ></CheckBox>
                        <p className="mx-1  cerificate-text">{certificate.name}</p>
                      </div>
                    </div>
                  )}
                </>
              ))
              }
              <div className='certificate-child-first log-certificate'>
                <div className="certificate-child-secound">
                  <CheckBox
                    checked={otherCheck}
                    onChange={(e) => handleOtherOptionCheckbox(e.target.checked)}
                    disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile)}
                  ></CheckBox>
                  <p className="mx-1  cerificate-text">Others</p>
                </div>
              </div>
            </div>
            <div className='row mt-2'>
              {
                map(selectedAdditionalCertificates, (certificate) => {
                  return (
                    <>
                      <div className="col-md-6 mt-2 mb-1">
                        <div className='upload-content full'>
                          <div className='upload-input'>
                            <h4 className='upload-text lh-1'>Upload {certificate.certi_name} <span className='text-danger'>*</span></h4>
                            <Choosefile
                              className={`form-control choose-pdf ${verrors[`certificate#@${certificate.slug}`] ? 'choose-pdf-error' : ''}`}
                              type="file"
                              accept="image/jpeg, image/png, image/jpg"
                              onChange={(e) => handleAdditionalCertificateChange(e, certificate.slug, certificate.certi_name)}
                              name={"LOG_PTR#@" + certificate.slug}
                              disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer || isInqUser)}
                              id={"LOG_PTR#@" + certificate.slug}
                            />

                            {verrors[`LOG_PTR#@${certificate.slug}`] && (
                              <p className="upload-faild-text my-1">
                                <span className="certificate-required">{verrors[`LOG_PTR#@${certificate.slug}`]}</span>
                              </p>
                            )}
                            <p className='upload-info'>Allowed PDF, JPEG, JPG or PNG. Max size of 2 MB</p>
                          </div>

                          <div className={`upload-img ${verrors[`LOG_PTR#@${certificate.slug}`] ? 'upload-img-error' : ''} `}>
                            { /** Preview of Existing file or uploaded file */}
                            <div className={`position-relative ${props.isDisable || props.disableProfile || isViewer || isInqUser ? ` ` : `certificate-img-hover`} `}>

                              {existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`] ? (
                                existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`].path.endsWith('.pdf') ? (
                                  <img src={pdf} alt="PDF Icon" style={style2} id="pdf-img" onClick={() => handlePdfShow(existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`]?.path)} className='line-964' />
                                ) : (
                                  <img src={existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`].path} alt="" style={style2} id="pdf-img" onClick={() => handleImageShow(existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`]?.path)} className='line-966' />
                                )
                              ) : additionalCerti[`LOG_PTR#@${certificate.slug}`] ? (
                                additionalCerti[`LOG_PTR#@${certificate.slug}`].fileType === 'pdf' ? (
                                  <img
                                    src={pdf}
                                    alt='PDF'
                                    style={style2}
                                    id="pdf-img"
                                  />
                                ) : (
                                  <img
                                    src={additionalCerti[`LOG_PTR#@${certificate.slug}`].path}
                                    alt='additional-cert-img'
                                    style={style2}
                                    id="pdf-img"
                                    className='line-982'
                                  />
                                )
                              ) : (
                                <></>
                              )}

                              <p className='upload-info'>{filenamepdf}</p>
                              {!isViewer && !isInqUser && !props.disableProfile && existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`]?.mcId && (
                                <button className='pdf-close' type='button' onClick={() => handleRemove(existingAdditionalCertificates[`LOG_PTR#@${certificate.slug}`]?.mcId)} disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer || isInqUser)}>
                                  <i className="fa-regular fa-trash-can text-danger"></i>
                                </button>
                              )}

                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                })
              }
            </div>
          </div>
        }

        {/** Setting Up AEO - IATA Certificate - END */}

        {verrors.certificateOption && <span className="company-required" style={styleError}>{verrors.certificateOption}</span>}

        {/** Setting Up Other Certificate - START */}
        {otherCheck && (

          <div className='row update-profile-wrapper mb-3'>

            <div className='col-xl-6 py-2'>
              <label className='profile-text'>Other Certificate Name<span className='text-danger'>{' '}*</span></label>

              <div className="d-flex">
                <div className="w-100">
                  <InputField
                    placeholder={"Enter certificate name"}
                    value={otherCerti}
                    onChange={(e) => setOtherCerti(e.target.value)}
                    className={"input-error-border my-1"}
                    onBlur={handleFocusOut}
                    name="other_certi"
                    disabled={(isSuperAdmin || isOpUser) ? false : props.isDisable || props.disableProfile || isViewer || isInqUser}
                    autoComplete="off"
                  />
                </div>

              </div>
              {errors.other_certi && (
                <div className="invalid-feedback" style={styleError}>
                  {errors.other_certi}
                </div>
              )}
            </div>
            <div className='col-xl-6'>
              <div className='upload-content full'>
                <div className='upload-input'>
                  <h4 className='upload-text pb-0'>Upload Other Certificate <span className='text-danger'>*</span></h4>
                  <Choosefile
                    className={`form-control choose-pdf ${verrors[`certificate#@${'other_certi'}`] ? 'choose-pdf-error' : ''}`}
                    type="file"
                    accept="image/jpeg, image/png, image/jpg"
                    onChange={(e) => handleAdditionalCertificateChange(e, 'other_certi', 'other_certi')}
                    name={"LOG_PTR#@other_certi"}
                    disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer || isInqUser)}
                    id={"LOG_PTR#@LOG_PTR#@other_certi"}
                  />
                  {verrors[`LOG_PTR#@other_certi`] && (
                    <p className="upload-faild-text my-1">
                      <span className="certificate-required">{verrors[`LOG_PTR#@other_certi`]}</span>
                    </p>
                  )}
                  <p className='upload-info'>
                    Allowed PDF, JPEG, JPG or PNG. Max size of 2 MB
                  </p>
                </div>
                <div className={`upload-img ${verrors[`LOG_PTR#@other_certi`] ? 'upload-img-error' : ''} `}>
                  <div className={`position-relative ${props.isDisable || props.disableProfile || isViewer || isInqUser ? ` ` : `certificate-img-hover`} `}>
                    {/* {additionalCerti && additionalCerti[`LOG_PTR#@other_certi`] ? <img
                                          src={additionalCerti[`LOG_PTR#@other_certi`] && additionalCerti[`LOG_PTR#@other_certi`].path}
                                          alt='other-certificate-img'
                                          style={style2}
                                          id="pdf-img"
                                          className='line-982'
                                      /> : existingOtherCertificate && existingOtherCertificate[`LOG_PTR#@other_certi`] ? <img
                                          src={existingOtherCertificate[`LOG_PTR#@other_certi`] && existingOtherCertificate[`LOG_PTR#@other_certi`].path}
                                          alt='other-certificate-img'
                                          style={style2}
                                          id="pdf-img"
                                          className='line-982'
                                      /> : <></>
                                      } */}

                    {existingOtherCertificate[`LOG_PTR#@other_certi`] ? (
                      existingOtherCertificate[`LOG_PTR#@other_certi`].path.endsWith('.pdf') ? (
                        <img src={pdf} alt="PDF Icon" style={style2} id="pdf-img" onClick={() => handlePdfShow(existingOtherCertificate[`LOG_PTR#@other_certi`]?.path)} className='line-964' />
                      ) : (<>
                        <img src={existingOtherCertificate[`LOG_PTR#@other_certi`].path} alt="" style={style2} id="pdf-img" onClick={() => handleImageShow(existingOtherCertificate[`LOG_PTR#@other_certi`]?.path)} className='line-1107' />
                      </>

                      )
                    ) : additionalCerti[`LOG_PTR#@other_certi`] ? (
                      additionalCerti[`LOG_PTR#@other_certi`].fileType === 'pdf' ? (
                        <img
                          src={pdf}
                          alt='PDF'
                          style={style2}
                          id="pdf-img"
                        />
                      ) : (
                        <img
                          src={additionalCerti[`LOG_PTR#@other_certi`].path}
                          alt='additional-cert-img'
                          style={style2}
                          id="pdf-img"
                          className='line-982'
                        />
                      )
                    ) : (
                      <></>
                    )}


                    {!isViewer && !isInqUser && !props.disableProfile && existingOtherCertificate[`LOG_PTR#@other_certi`]?.mcId && (
                      <button className='pdf-close' type='button' onClick={() => handleRemove(existingOtherCertificate[`LOG_PTR#@other_certi`]?.mcId)} disabled={(isSuperAdmin || isOpUser) ? false : (props.isDisable || props.disableProfile || isViewer || isInqUser)}>
                        <i className="fa-regular fa-trash-can text-danger"></i>
                      </button>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>

        )}

        {/** Setting Up Other Certificate - END */}

        {(!props.disableProfile && !isViewer && !isInqUser) && (
          <div className="profile-btn border-top mt-2">
            <ButtonAdminpanel className="mt-4" type="submit" disabled={(isSuperAdmin || isOpUser) ? isButtonDisabled : (props.isDisable || props.disableProfile || isButtonDisabled)}>
              Save Changes
            </ButtonAdminpanel>
          </div>
        )}

      </form>

      <SmallPopup
        title="Delete Certificate"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete?</div>
        </div>

      </SmallPopup>

      <MediumPopup
        title="Certificate"
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
        closeButtonLabel="Cancel"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">
            <img src={docImagePath} alt="Placeholder" style={style3} id="pdf-img" />
          </div>
        </div>

      </MediumPopup>

      <MediumPopup
        title="Certificate"
        mediummodalShow={mediummodalShow2}
        setMediumModalShow={setMediumModalShow2}
        closeButtonLabel="Cancel"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0" style={{ height: "500px" }}>
            <embed src={`${docPdfPath}#toolbar=0`} type='application/pdf' style={style3} id="pdf-img" />
          </div>
        </div>
      </MediumPopup>

    </div>
  )
}
const mapStateToProps = state => {
  return {
    getMemberCertificate: state.update.getMemberCertificate,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getMemberTradeMode: (member_id) => dispatch(getMemberTradeMode(member_id)),
    getCertificateAdmin: (trade_mode) => dispatch(getOptionListAdmin(trade_mode)),
    getCertificateSearch: (searctText, trade_mode) => dispatch(getCertificateSearchList(searctText, trade_mode)),
    // getSelectedCertificateListById: (ids, trade_mode) => dispatch(getSelectedCertificateListByIdList(ids, trade_mode)),
    addCertificates: (id, data, data2, tradeMode, logData, otherCheck, otherCerti) => dispatch(addCertificateAction(id, data, data2, tradeMode, logData, otherCheck, otherCerti)),
    getMemberCertificate: (member_id) =>
      dispatch(getMemberCertificateAction(member_id)),
    deleteCertificate: (id) => dispatch(deleteCertificate(id)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(LogisticPartnerCertificate);
